// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".content[data-v-4afe3395]{-webkit-tap-highlight-color:transparent;cursor:pointer;display:flex;justify-content:center;height:4rem}", ""]);
// Exports
module.exports = exports;
